import { apiClient } from './apiClient';

export type AccessReportUser = {
  userId: string;
  name: string;
  email: string;
  isActive: boolean;
  lastAccessAtUtc?: string | null;
  averageNavigationSeconds?: number | null;
  sessionCount: number;
};

export type AccessReportResult = {
  items: AccessReportUser[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export async function listAccessReport(params?: {
  page?: number;
  pageSize?: number;
  search?: string;
}): Promise<AccessReportResult> {
  const response = await apiClient.get<AccessReportResult>('/v1/reports/access', {
    params: {
      page: params?.page ?? 1,
      pageSize: params?.pageSize ?? 50,
      search: params?.search?.trim() || undefined,
    },
  });
  return response.data;
}

export async function postNavigationHeartbeat(
  clientSessionKey: string,
): Promise<{ sessionId: string; clientSessionKey: string; lastHeartbeatAtUtc: string }> {
  const response = await apiClient.post('/v1/activity/heartbeat', { clientSessionKey });
  return response.data;
}
